<template>
  <div id="transport">
    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>运输溯源&nbsp;/&nbsp;运输管理</span>
        </div>
        <div style="display: flex;flex-wrap: wrap;align-items: center;">
            <Provinces @gain='gainSS'></Provinces>
           <el-input class="elinputs" v-model="beginData.id" placeholder="编号"></el-input>
           <el-input class="elinputs" v-model="beginData.departure" placeholder="出发地"></el-input>
           <el-input class="elinputs" v-model="beginData.licenseName" placeholder="司机姓名"></el-input>
           <el-input class="elinputs" v-model="beginData.truckNumber" placeholder="车牌号"></el-input>
            <el-button type="primary" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0.4)" v-loading.fullscreen.lock="fullscreenLoading" @click="query">查询</el-button>
            <el-button type="info" @click='resets'>重置</el-button>
        </div>
        <div class="tit">
            <Reset @clkBtn='theBtn'></Reset>
            <Xlsx :name="formname"></Xlsx>
        </div>
        <el-table :data="tableData" id="exportTab" @selection-change="handleSelectionChange" border stripe style="width: 100%">
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
            <el-table-column prop="sn" label="车次" sortable width="120"></el-table-column>
            <el-table-column prop="truckNumber" label="车牌号" width="120"></el-table-column>
            <el-table-column label="货物信息" width="140">
                <template slot-scope="scope">
                    <p class="boldfont" style="color:#11A983;text-decoration:underline;cursor: pointer;" @click="indentgj(scope.row)">查看</p>
                </template>
            </el-table-column>
            <el-table-column prop="licenseName" label="司机姓名" width="120"></el-table-column>
            <el-table-column prop="departureTime" label="出发时间" width="160"></el-table-column>
            <el-table-column prop="areasName" label="所属地区" width="160"></el-table-column>
            <el-table-column prop="departurePlace" label="出发地" width="260"></el-table-column>
            <el-table-column label="车辆轨迹" width="140">
                <template slot-scope="scope">
                    <p class="boldfont" style="color:#11A983;text-decoration:underline;cursor: pointer;" @click="cargjOne(scope.row)">查看</p>
                </template>
            </el-table-column>

            <el-table-column label="状态" width="160">
                <template slot-scope="scope">
                    <p class="boldfont" v-if="scope.row.status==1">待出发</p>
                    <p class="boldfont" v-if="scope.row.status==2">在途中</p>
                    <p class="boldfont" v-if="scope.row.status==3">已完成</p>
                </template>
            </el-table-column>
            <el-table-column prop="finishTime" label="完成时间" width="180"></el-table-column>
            <el-table-column prop="addTime" label="添加时间" width="180"></el-table-column>
            <el-table-column prop="updateTime" label="修改时间" width="180"></el-table-column>
            <el-table-column label="操作" fixed="right" min-width="200">
                <template slot-scope="scope">
                <el-button size="mini" type="success" @click="handleEdit(1,scope.row,'transport:update')"><i class="el-icon-edit"></i> 编辑</el-button>
                <el-button size="mini" type="danger" @click="stop(scope.row,'transport:delete')"><i class="el-icon-delete"></i> 删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="paging">
            <span>
            共
            <i class="pagingNum">{{total}}</i> 条
            </span>
            <Paging :gopage="total" @pag="pag"></Paging>
        </div>
    </el-card>
    <el-dialog :title="mydata.names" :visible.sync="dialogFormVisible" width="60%" @close="dataClose">
        <el-form>
            <el-form-item label="* 所属地区：">
                <el-select v-model="sheng" placeholder="省份" @change="cksheng">
                    <el-option
                    v-for="item in shenglist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
                <el-select v-model="shi" placeholder="城市" @change="ckshi" class="cty16">
                    <el-option
                    v-for="item in shilist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 车牌号：">
                <el-select v-model="mydata.truckId" placeholder="选择空闲车辆">
                    <el-option
                    v-for="item in beginData.car"
                    :key="item.id"
                    :label="item.number"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 司 机：">
                <el-select v-model="mydata.licenseId" placeholder="选择空闲司机">
                    <el-option
                    v-for="item in beginData.driver"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 状 态：">
                <el-select v-model="mydata.status" placeholder="出发状态">
                    <el-option
                    v-for="item in beginData.gogogo"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 出发时间：">
                <div class="block">
                    <el-date-picker v-model="mydata.departureTime" type="datetime" value-format="yyyy-MM-dd HH:mm" placeholder="出发时间">
                    </el-date-picker>
                </div>
            </el-form-item>
            <el-form-item label="  完成时间：">
                <div class="block">
                    <el-date-picker v-model="mydata.finishTime" type="datetime" value-format="yyyy-MM-dd HH:mm" placeholder="完成时间">
                    </el-date-picker>
                </div>
            </el-form-item>
            <el-form-item label="* 出发地：">
               <el-input placeholder="选择出发地" v-model="mydata.departurePlace" auto-complete="off"></el-input>
                <el-button size="small" type="primary" @click="innerVisible=true" style="margin-left: 20px;">点击选择出发地</el-button>
            </el-form-item>
        </el-form>
        <el-dialog title="选择出发地" :visible.sync="innerVisible" append-to-body id="datatext" width="60%">
            <el-form>
                <div style="position: relative;">
                    <label class="site">搜索地址：<input v-model="keyword"></label>
                    <baidu-map class="map" id="mapID" center="成都市" :zoom="zoom" :scroll-wheel-zoom="true" @click="getPoint">
                        <!--地图类型，两种：一种是路线一种是绿的那种-->
                        <!-- <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_TOP_LEFT"></bm-map-type> -->
                        <!--地图搜索功能，绑定上面的input，-->
                        <!--display: none样式很关键，因为下面默认会有地址提示信息很长，很烦，这样搜索会很舒服，-->
                        <!--zoom是搜索结果的视图比例，个人觉得12.8很舒服显示-->
                        <bm-local-search :keyword="keyword" :auto-viewport="true" :location="location" zoom="12.8" style="display: none"></bm-local-search>
                        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
                        <!--信息窗口，show属性是控制显示隐藏，infoWindowClose和infoWindowOpen是控制信息窗口关闭隐藏的方法-->
                        <bm-marker :position="postionMap">
                            <bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen" style="font-size: 14px">
                                <p style="width: 96%;">站点地址：{{ add.site }}</p>
                                <span class="xzadress" @click="xzsite">选择该地点</span>
                            </bm-info-window>
                        </bm-marker>
                    </baidu-map>
                </div>
            </el-form>
        </el-dialog>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="puton">确 定</el-button>
        </div>
    </el-dialog>
    <el-dialog title="车辆轨迹" :visible.sync="dialogFormVisible1" width="60%" @close="closeCar">
        <baidu-map class="map" :center="markerPoint" :zoom="zoom" :scroll-wheel-zoom="true" @zoomend="syncCenterAndZoom">
            <bm-marker :position="transportData.initial" :icon="{url:imgentrepot, size: {width: 48, height: 44}}">

            </bm-marker>
            <bm-polyline :path="polylinePath" stroke-color="red" :stroke-opacity="0.5" :stroke-weight="8" @lineupdate="updatePolylinePath"></bm-polyline>
            <bm-marker :position="markerPoint" :icon="{url: imgcar, size:{width:48,height: 36}}" @click="infoWindowOpen">
                <bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen">
                    <p>车&emsp;次：{{transportData.sn}}</p>
                    <p>车牌号：{{transportData.truckNumber}}</p>
                    <p>时&emsp;速：{{transportData.speed}} km/h</p>
                    <p>司&emsp;机：{{transportData.licenseName}}</p>
                </bm-info-window>
            </bm-marker>
        </baidu-map>
        <!-- <p @click='haha'>ceshi</p> -->
    </el-dialog>
    <el-dialog title="货物信息" :visible.sync="dialogFormVisible3" width="60%" @close="dataClose">
        <el-table :data="tableData2" border stripe style="width: 100%">
            <el-table-column prop="id" label="编号" width="60" :index="1"></el-table-column>
            <el-table-column prop="orderSn" label="订单编号" width="160"></el-table-column>
            <el-table-column prop="goodsName" :show-overflow-tooltip="true" label="商品名称" width="160"></el-table-column>
            <el-table-column prop="userName" label="下单用户" width="160"></el-table-column>
            <el-table-column prop="consignee" label="收货人" width="160"></el-table-column>
            <el-table-column prop="mobile" label="联系电话" width="160"></el-table-column>
            <el-table-column label="订单状态" sortable width="160">
                <template slot-scope="scope">
                    <p class="boldfont">{{stat(scope.row.orderStatus)}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="province" label="省份" width="120"></el-table-column>
            <el-table-column prop="city" label="城市" width="120"></el-table-column>
            <el-table-column prop="district" label="区/县" width="120"></el-table-column>
            <el-table-column prop="address" label="详细地址" width="120"></el-table-column>
            <el-table-column prop="message" label="买家留言" width="200"></el-table-column>
            <el-table-column prop="goodsPrice" label="商品价" width="120"></el-table-column>
            <el-table-column prop="couponPrice" label="优惠券" width="120"></el-table-column>
            <el-table-column prop="freightPrice" label="运费" width="120"></el-table-column>
            <el-table-column prop="actualPrice" label="实付款" width="120"></el-table-column>
            <el-table-column prop="orderPrice" label="结算价" width="120"></el-table-column>
            <!-- <el-table-column prop="readFalse" label="配送方式" width="120"></el-table-column> -->
            <el-table-column prop="addTime" label="下单时间" width="120"></el-table-column>
            <el-table-column prop="payTime" label="支付时间" width="120"></el-table-column>
            <el-table-column prop="shipTime" label="发货时间" width="120"></el-table-column>
            <el-table-column prop="confirmTime" label="收货时间" width="120"></el-table-column>
        </el-table>
          <div class="paging">
        <span>
          共
          <i class="pagingNum">{{cargo.total}}</i> 条
        </span>
        <Paging :gopage="cargo.total" @pag="pags"></Paging>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Reset from "@/components/Reset";
import Xlsx from "@/components/Xlsx";
import EditorBar from '@/components/Richtext'
import Paging from '@/components/Paging';
import Provinces from "@/components/Provinces";
export default {
  name: "transport",
  components: {
    Xlsx,
    EditorBar,
    Reset,
    Paging,
    Provinces
  },
  data() {
    return {
        beginData:{
            car:[],driver:[],gogogo:[{name:'待出发',id:'1'},{name:'在途中',id:'2'},{name:'已完成',id:'3'}]
        },
        tableData: [],
        tableData2:[],
        pageNum: 1,
        pageSize: 10,
        dialogFormVisible: false,
        dialogFormVisible1: false,
        dialogFormVisible3: false,
        userdata: {},
        total: 0,
        btn: [],
        fullscreenLoading: true,
        formname: JSON.stringify({name:'运输管理',hint:'transport:export'}),
        mydata:{},
        multipleSelection:[],
        innerVisible:false,
        postionMap:{  //地图坐标
            lng: 120.211486,
            lat: 30.256576
        },
        location: '',
        keyword: '',  //搜索框关键词
        zoom: 12.8,   //放大比例
        address:'',   //位置详细信息
        add:{
            siteName:'',
            site:'',
            jd:'',
            wd:'',
            desce:'',
        },
        imgcar: require("../../assets/img/car.png"),
        imgentrepot:require("../../assets/img/entrepot.png"),
        polylinePath: [],
        markerPoint:{lng: 116.401856, lat: 39.913927},
        show:true,
        ceshi:[
            {lat: "30.476200850079998",lng: "105.57924354896"}
        ],
        lala:0,
        cargo:{pageNum: 1,pageSize: 10,total:0,id:''},
        transportData:{},
        sheng:'',
        shi:'',
        shenglist:[],
        shilist:[],
    };
  },
  created() {
    let userdata = JSON.parse(sessionStorage.getItem("userdata"));
    this.$set(this, "userdata", userdata);
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    this.begin();
  },
  computed: {
    data() {
      return this.tableData;
    }
  },
  mounted() {
      let region = JSON.parse(localStorage.getItem('region'))
    region.forEach(x => {
        if(x.level==0){
            this.shenglist.push(x)
            this.sheng=x.id
        }
    });
    if(this.userdata.level==0){
        this.$axios.post(`/api-r/area/getSubordinateAreaList`,this.$qs.stringify({areasId:region[0].id}),{headers:{accessToken:this.userdata.token}})
        .then(res=>{
            if(res.data.success){
                this.$set(this,'shilist',res.data.areaListInfoList)
            }
        })
    }else{
        region.forEach(x=>{
            if(x.level==1){
                this.shilist.push(x)
            }
        })
        if(this.shilist.length==1){
            this.shi=this.shilist[0].id
            this.mydata.areasId = this.sheng +','+ this.shilist[0].id
            this.mydata.areasName = this.userdata.areasName
        }
    }
  },
  methods: {
    // 获取省市传入的id
    gainSS(i){
        this.beginData.areaId = i.id
    },
    cksheng(val){
        this.$set(this,'shi','')
    },
    ckshi(val){
        this.mydata.areasId = this.sheng +','+ val
        let arr = []
        this.shenglist.forEach(x=>{
            if(this.sheng==x.id){
                arr.push(x.name)
            }
        })
        this.shilist.forEach(x=>{
            if(val==x.id){
                arr.push(x.name)
            }
        })
        this.mydata.areasName = arr.join(',')
    },
    resets(){
        this.$router.push('/refresh')
    },
    //   判断当前点击的按钮
    theBtn(i){
        if(i==1){
            if(this.btn.indexOf('transport:add')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            this.handleEdit(0)
        }else if(i==2){
            if(this.btn.indexOf('transport:update')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            if(this.multipleSelection.length != 1){
                return this.$message('请勾选一项内容编辑')
            }
            this.handleEdit(1,this.multipleSelection[0])
        }else if(i==3){
            if(this.btn.indexOf('transport:delete')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            this.choice()
        }else if(i==4){
            this.query()
        }
    },
      stat(i){
        if(i==0){
            return `待支付`
        }else if(i==1){
            return `待发货`
        }else if(i==2){
            return `已发货`
        }else if(i==3){
            return `已收货`
        }else if(i==4){
            return `已完成`
        }else if(i==5){
            return `已退款`
        }else if(i==6){
            return `已关闭`
        }else if(i==7){
            return `已无效`
        }else if(i==8){
            return `退款中`
        }
    },
    pags(val){
        this.cargo.pageNum = val.pageNum
        this.cargo.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.indentgj(this.cargo.id)
    },
    //   货物信息查看
    indentgj(row){
        this.cargo.id=row.id
        this.fullscreenLoading = true
        let data = this.$qs.stringify({
            pageNum: this.cargo.pageNum,
            pageSize: this.cargo.pageSize,
            transportId:row.id,
            adminAreasId: this.userdata.areasId
        });
        this.$axios.post(`/api-s/getOrderList`,data,{headers:{accessToken:this.userdata.token}})
        .then(res=>{
            this.fullscreenLoading = false
            if(res.data.success){
                if(res.data.pageInfo.list.length==0){
                    this.$message('暂无货物信息')
                    return
                }
                this.cargo.total = res.data.pageInfo.total
                this.tableData2 = res.data.pageInfo.list
                this.dialogFormVisible3 = true
            }
        })
    },
    // 老司机的车
    haha(){
      this.polylinePath.push(this.ceshi[this.lala])
      this.markerPoint = this.ceshi[this.lala]
      this.lala++
    },
    updatePolylinePath (e) {
      this.polylinePath = e.target.getPath()
    },
    syncCenterAndZoom(e){
      this.zoom = e.target.getZoom()
    },
    //   获取用户车辆轨迹
    cargj(row){
        this.$axios.post(`/api-s/getGpsInfoList/${row.id}`,{},{headers:{accessToken:this.userdata.token}})
        .then(res=>{
            this.fullscreenLoading = false
            if(res.data.success){
                if(res.data.gpsInfoList.length==0){
                    this.$message('暂无车辆轨迹信息')
                    clearInterval(this.timer);
                    return
                }
                this.dialogFormVisible1 = true
                let log = []
                let dataArr = res.data.gpsInfoList
                dataArr.forEach(x=>{
                    log.push({lng:x.lon,lat:x.lat})
                })
                this.polylinePath = log
                this.markerPoint = {lng:log[log.length-1].lng, lat:log[log.length-1].lat}
                res.data.transportRecordInfo.initial = {lng:log[0].lng, lat:log[0].lat}
                res.data.transportRecordInfo.speed = dataArr[dataArr.length-1].spe
                // // 信息处理
                this.transportData = res.data.transportRecordInfo
            }else{
                this.$message(res.data.msg)
            }
        })
    },
    cargjOne(row){
        const _this = this
        this.fullscreenLoading = true
        _this.timer = setInterval(function() {
            _this.cargj(row)
        },5000)
        _this.cargj(row)
    },
    closeCar(){
        clearInterval(this.timer);
    },
    getPoint(e){    //点击地图获取一些信息，
        this.show = true;
        this.postionMap.lng = e.point.lng;     //通过  e.point.lng获取经度
        this.postionMap.lat = e.point.lat;     //通过  e.point.lat获取纬度
        this.add.jd = e.point.lng;
        this.add.wd = e.point.lat;
        this.zoom = e.target.getZoom()
        let geocoder= new BMap.Geocoder();  //创建地址解析器的实例
        geocoder.getLocation(e.point,rs=>{
            this.add.site = rs.address;
            this.add.siteName = rs.address;
        })
    },
    // 地址选择
    xzsite(){
        this.mydata.lat = this.add.wd
        this.mydata.lng = this.add.jd
        this.mydata.departurePlace = this.add.siteName
        this.innerVisible = false
    },
    infoWindowClose () {
        this.show = false
    },
    infoWindowOpen () {
        this.show = true
    },
    // 查询可分配的车辆和司机下拉框
    car(){
        this.$axios.post(`/api-s/getAllTruckList/${this.userdata.areasId}`,{},{headers:{accessToken:this.userdata.token}})
        .then(res=>{
            if(res.data.success){
                this.beginData.car = res.data.truckInfos
            }
        })
        this.$axios.post(`/api-s/getLicenseList/${this.userdata.areasId}`,{},{headers:{accessToken:this.userdata.token}})
        .then(res=>{
            if(res.data.success){
                this.beginData.driver = res.data.licenseInfos
            }
        })
    },
    //   多选删除
    choice(){
        if(this.multipleSelection.length == 0){
            return this.$message('请至少选择一项删除')
        }
        let arr = []
        this.multipleSelection.forEach(x=>{
            arr.push(x.id)
        })
        this.$confirm('此操作将删除选中内容, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let url = ``
            url = `/api-s/deleteTransportRecord/${arr.join(',')}`
            this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
            .then(res=>{
                if(res.data.success==true){
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    });
                    this.begin();
                }else{
                    alert(res.data.msg)
                }
            })
        }).catch(() => {
            return
        });
    },
    // 关闭清空内容
    dataClose(){
        if(this.shilist.length==1){
            this.mydata={areasId:this.sheng +','+ this.shilist[0].id,areasName:this.userdata.areasName}
        }else{
            this.shi = ''
            this.mydata={}
        }
        this.begin()
    },
    //   多选编辑
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    //   确定
    puton(){
        if(!this.mydata.truckId||!this.mydata.licenseId||!this.mydata.status||!this.mydata.departureTime){
            this.$message('请完善必填信息')
            return
        }
        // 判断是点击哪个
        let url = ``
        if(this.mydata.stat==0){
            if(!this.mydata.departurePlace||!this.mydata.lng){
                this.$message('请选择出发地')
                return
            }
            url = `/api-s/addTransportRecord`
        }else if(this.mydata.stat==1){
            url = `/api-s/updateTransportRecord`
        }
        this.fullscreenLoading = true;
        this.$axios.post(url,this.$qs.stringify(this.mydata),{ headers: { accessToken: this.userdata.token } })
        .then(res => {
            if(res.data.success){
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
                this.dialogFormVisible = false
            }else{
                this.$message(res.data.msg)
                this.fullscreenLoading = false;
            }
        });
    },
    reset() {
      this.beginData = {car:[],driver:[],gogogo:[{name:'待出发',id:'1'},{name:'在途中',id:'2'},{name:'已完成',id:'3'}]};
      this.begin();
    },
    pag(val){
        this.pageNum = val.pageNum
        this.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.begin()
    },
    begin() {
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        id:this.beginData.id,
        departure:this.beginData.departure,
        licenseName:this.beginData.licenseName,
        truckNumber:this.beginData.truckNumber,
        adminAreasId: this.userdata.areasId,
        areaId:this.beginData.areaId
      });
      this.$axios.post(`/api-s/getTransportRecordList`, data, {headers: { accessToken: this.userdata.token }})
        .then(res => {
            this.fullscreenLoading = false;
            if(res.data.success){
                this.$nextTick(function(){  //不使用this.$nextTick()方法会报错
                    this.$set(this, "tableData", res.data.pageInfo.list);
                });
                this.$set(this, "total", res.data.pageInfo.total);
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
            }else{
              this.$message(res.data.msg)
            }
        });
    },
    handleEdit(i,row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message('抱歉，用户暂无该权限')
        }
        this.car()
        if(i == 0){
            this.mydata.names = '添加运输车次'
            this.mydata.stat = i
        }else if(i == 1){
            row.names = '编辑运输车次'
            row.stat = i
            row.status += ''
            if(row.areasId){
                this.sheng = Number(row.areasId.split(',')[0])
                this.shi = Number(row.areasId.split(',')[1])
            }
            this.mydata = row
        }
        this.dialogFormVisible = true
    //   this.$set(this, "information", i);
    },
    // 删除优惠券
    stop(row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message('抱歉，用户暂无该权限')
        }
      this.$confirm('此操作将删除该条内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          let url = ``
          url = `/api-s/deleteTransportRecord/${row.id}`
          this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
          .then(res=>{
              if(res.data.success==true){
                  this.$message({
                      type: 'success',
                      message: res.data.msg
                  });
                  this.begin();
              }else{
                  alert(res.data.msg)
              }
          })
      }).catch(() => {
          return
      });
    },
    query() {
      this.fullscreenLoading = true;
      this.begin();
    }
  }
};
</script>
<style>
#transport .map {
  width: 100%;
  height: 500px;
}
#mapID {
  width: 100%;
  height: 60vh;
}
#transport .BMap_bubble_content{
    height: 100%;
    width: 96%;
}
.w-e-toolbar{
  flex-wrap: wrap;
}
#transport .el-input__inner {
  margin: 10px 0;
}
#transport .el-menu.el-menu--horizontal{
  margin-bottom: 14px;
}
#transport .el-menu-item.is-active{
  background: none
}
#transport .el-date-editor.el-input,#transport  .el-date-editor.el-input__inner{
    width: 100%;
}
#transport .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#transport .el-tag{
  margin-right: 12px;
}
#transport .el-select {
  /* margin: 0 8px; */
  width: 100%
}
#transport .block{
    width: 100%
}
#transport .el-range-editor.el-input__inner{
   width: 100%
}
#transport .el-upload__tip {
    display: inline-block;
    margin-left: 14px;
}
.input-new-tag{
  width: 20%
}
#transport .el-upload-list--picture .el-upload-list__item {
    width: 44%;
    float: left;
    margin-right: 2%;
}
#transport .el-form-item__content {
    /* width: 52%; */
    display: flex;
    width: 100%;
    align-items: center;
}
#transport .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#transport .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#transport .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
#transport .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#transport .el-dialog__body {
  height: 100%
}
#transport .el-form-item{
    display: flex;
    align-items: center;
    margin-bottom:0
}
#transport .el-form-item__label{
    width: 130px;
}
.viewer-transition {
  z-index: 9999 !important;
}
</style>
<style scoped lang="scss">
.clearfix{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.sfzimg {
  height: 48px;
}
#help .myxx p {
  margin: 5px 0;
  font-size: 16px;
}
h5 {
  text-align: center;
  margin-top: 12px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.tx{
      color: red;
    margin-left: 8px;
}
.summary>span:first-child{
    margin-right: 20px
}
.summary>span:first-child i{
    color:red
}
.summary>span:last-child i{
    color:green
}
.staimg{
    position: absolute;
    left: -26px;
    top: 10px;
    width: 18px;
}
.dtstat span{
    margin: 0 34px;
}
.site{
    position: absolute;
    top: 6%;
    z-index: 99;
    left: 2%;
}
.site input{
    width: 258px;
    line-height: 36px;
}
.xzadress{
    float: right;cursor: pointer;text-decoration: underline;color: red;margin-right: 18px;
}
</style>
